import { forwardRef, LabelHTMLAttributes, ReactNode } from 'react'
import cn from 'classnames/bind'
import split from 'ramda/es/split'
import intersperse from 'ramda/es/intersperse'

import isProduction from 'app/common/lib/isProduction'

import styles from './plain-label.module.scss'

const cx = cn.bind(styles)

export type Props = {
  children: ReactNode
  id?: string
  htmlFor?: string
  className?: string
  disabled?: boolean
  skipUpperSpace?: boolean
  skipBottomSpace?: boolean
  displayAsBlock?: boolean
  hidden?: boolean // hide
  invisible?: boolean // hide but take place
  babyLabel?: boolean
} & LabelHTMLAttributes<HTMLLabelElement>

const PlainLabel = forwardRef<HTMLLabelElement, Props>(
  (
    {
      children,
      id,
      htmlFor,
      className,
      disabled,
      skipUpperSpace,
      skipBottomSpace,
      displayAsBlock,
      hidden,
      invisible,
      babyLabel,
      ...other
    }: Props,
    ref,
  ) => {
    if (!isProduction() && !htmlFor && !id) {
      console.error('Не указан один из обязательных параметров `htmlFor` или `id`')
    }

    const classNameLabel = cx(
      styles.root,
      {
        disabled,
        skipUpperSpace,
        skipBottomSpace,
        displayAsBlock,
        hidden,
        babyLabel,
        invisible,
      },
      className,
    )

    return (
      <label id={id} htmlFor={htmlFor} ref={ref} className={classNameLabel} {...other}>
        {typeof children === 'string'
          ? intersperse('###', split('<br />', children)).map((str, i) =>
              str === '###' ? <br key={i} /> : str,
            )
          : children}
      </label>
    )
  },
)

export default PlainLabel
